import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";

export default function LoaderWithMsg({ isLoading, loaderMsg }) {
    return (
        <Modal
            open={isLoading}
            sx={[
                {
                    ".MuiBackdrop-root": {
                        background: "rgba(193, 201, 210, 0.7)",
                    },
                },
            ]}
            disableAutoFocus={true}
        >
            <Box
                style={{
                    color: 'rgb(25, 118, 210)',
                    verticalAlign: 'middle',
                    position: 'absolute',
                    top: '50%',
                    width: '20%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '1rem'
                }}
                sx={{
                    width: 200,
                    height: 60,
                    backgroundColor: 'tranperant',
                    '&:hover': {
                        backgroundColor: 'white',
                    },
                }}
            >
                <CircularProgress />
                <p style={{
                    // color: "black",
                    fontSize: "20px"
                }}>{loaderMsg}</p>
            </Box>
        </Modal>
    );
}
